import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import LoaderComponent from "../../Common/LoaderComponent";
import useRequiredFields from "../../../hooks/useRequiredFields";
import IsLogin from "../../Common/IsLogin";
import Http from "../../Common/Http";

const Create = () => {
    const navigate = useNavigate();
    const [inputs, setInputs] = useState({}); // ✅ Fix: Initialize inputs properly
    const [error, setError] = useState({});
    const { checkRequiredFields } = useRequiredFields();

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setInputs((values) => ({ ...values, [name]: value }));
    }

    console.log(inputs)
 
    const formSubmit = async (e) => {
        e.preventDefault();
        
        const { isValid, error } = checkRequiredFields(inputs);
        if (!isValid) {
             setError(error);
        }

        try {
            await Http.post("/code", inputs).then((res) => {
                console.log(res);
            });
            navigate("/code");
        } catch (err) {
            Swal.fire("Error!", "Something went wrong.", "error");
        }
    };

    return (
        <>
            <IsLogin />
            <LoaderComponent />
            <div className="am-mainpanel">
                <div className="am-pagetitle g-2">
                    <h5 className="am-title">Code</h5>
                    <Link to="/code" className="btn btn-primary">
                        <i className="fa fa-bars mg-r-6"></i> List
                    </Link>
                </div>
                <div className="am-pagebody">
                    <div className="card pd-20 pd-sm-40">
                        <div className="table-wrapper">
                            <form onSubmit={formSubmit}>
                                <div className="form-group">
                                    <label htmlFor="codes">Code Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="code"
                                        onChange={handleChange}
                                        data-required="true"
                                    />
                                </div>
                                <button type="submit" className="btn btn-primary">Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Create;
